const roles = {
  ReadOnly: 'readOnly',
  Contributor: 'contributor',
  Admin: 'admin',
  ShowCaller: 'showCaller'
};

export default roles;
